import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Images } from "config/images";

const useStyles = makeStyles(
	theme =>
		createStyles({
			rootBanner: {
				backgroundImage: `url(${Images.bannerLoyalty})`,
				backgroundRepeat: "no-repeat",
				backgroundSize: "100% 100%",
				padding: "8px 16px 32px 16px",
				display: "flex"
			},
			backgroundBanner: {
				position: "relative",
				boxShadow: "0px 3px 29px rgba(114, 136, 128, 0.15)",
				borderRadius: 6
			},
			footerBanner: {
				position: "absolute",
				bottom: 0,
				width: "100%",
				minHeight: 12,
				borderRadius: "0px 0px 6px 6px",
				padding: "3px 0px",
				textAlign: "center",
				fontSize: 12,
				fontWeight: 500,
				color: "white",
				"& >span": {
					color: theme.palette.text.main
				}
			},
			left: {
				width: "70%"
			},
			right: {
				width: "30%"
			},
			title: {
				fontSize: 12,
				color: "white",
				fontWeight: 500
			},
			titlePrice: {
				fontSize: 18,
				color: "white",
				fontWeight: 700,
				display: "flex",
				alignItems: "center",
				marginTop: 5,
				"& >img": {
					marginRight: 5,
					width: 18,
					height: 18
				}
			},
			bannerSales: {
				borderRadius: 50,
				fontSize: 12,
				fontWeight: 500,
				color: "white",
				width: "fit-content",
				padding: "2px 10px"
			},
			bannerBonus: {
				borderRadius: 50,
				fontSize: 10,
				fontWeight: 500,
				color: "white",
				width: "fit-content",
				padding: "2px 5px"
			},
			centerItem: {
				justifyContent: "center",
				display: "flex",
				marginTop: 5,
				"& >img": {
					width: 58,
					height: 58
				}
			},
			btnInfo: {
				right: 10,
				position: "absolute",
				top: 10,
				cursor: "pointer",
				"& :hover": {
					opacity: 0.7
				}
			}
		}),
	{
		name: "BannerLoyalty",
		index: 1
	}
);

export default useStyles;
